import React, {Fragment} from 'react';
import {Redirect} from "react-router-dom";
import requestApi from "../../services/requestApi.service";
import Header from "../../Layout/AppHeader";
import Common from "../../Common/Common";
import {getHostPrefix, setCookie, setSessionValue, validateLogin} from "../../Common/Appcommon";
import {
    setAppCustomTitle
} from "../../reducers/ThemeOptions";
import {connect} from "react-redux";
class MobileLogin extends React.Component{
    constructor(props) {
        super(props);
        let appid = props.match !== undefined && props.match.params.appid !== undefined ? props.match.params.appid : '';
        appid = decodeURIComponent(appid);
        let username = props.match !== undefined && props.match.params.username !== undefined ? props.match.params.username : '';
        username = decodeURIComponent(username);
        let password = props.match !== undefined && props.match.params.password !== undefined ? props.match.params.password : '';
        password = decodeURIComponent(password);
        const url = window.location.href;
        const [path, queryString] = url.split('?');
        let idParam = "";
        if(queryString !== undefined && queryString !== "" && queryString !== null){
            idParam = queryString.split("=")[1];
        }
        this.state = {
            appid : appid,
            username : username,
            password : password,
            chatId : idParam,
        }
    }

    componentDidMount = async () => {
        let {username, password, appid, chatId} = this.state;
        let params = {
            "ENTITY" : "LoginRequest",
            "username" : username,
            "pwd" : password,
            "APPID" : appid,
            "productid" : "",
            "builderid" : "",
            "usertableid" : "",
            "requestfrom" : "Mobile"
        }
        setSessionValue('appid', appid);
        let res = await requestApi.processServerRequest(params);
        if(res.issuccess){
            let loginres = res.data;
            if(loginres !== undefined && loginres.length > 0){
                let loginUserId = loginres[4];
                let prefix = getHostPrefix();
                setCookie(prefix+'loginappid', appid);
                setCookie(prefix+'loginusertableid',loginUserId);
                await validateLogin(this.props.history, false);
                let pushUrl = "/inbox";
                if(chatId !== ""){
                    pushUrl = "/inbox/chat/"+chatId;
                }
                this.props.history.push(pushUrl);
            }
        }
    };


    render() {
        return (
            <Fragment>
                <div >
                    Loading
                </div>

            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle
});

const mapDispatchToProps = dispatch => ({
    setAppCustomTitle: title => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileLogin);
